import { render, staticRenderFns } from "./MobileCreateCollaboration.vue?vue&type=template&id=e668ec78&scoped=true&"
import script from "./MobileCreateCollaboration.vue?vue&type=script&lang=ts&"
export * from "./MobileCreateCollaboration.vue?vue&type=script&lang=ts&"
import style0 from "./MobileCreateCollaboration.vue?vue&type=style&index=0&id=e668ec78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e668ec78",
  null
  
)

export default component.exports